import axios from 'axios';
import {
  ALARMS,
  DAILY_DATA,
  EVENT_DESCRIPTION,
  EVENT_LOG_LATEST,
  FIRST_VALUE_YEAR,
  INVERTER,
  INVERTER_GET_PARAMS,
  INVERTER_SEARCH,
  INVERTER_STATUS,
  LOGIN,
  MAX_POWER,
  MICROSERVICE_EVENT_PREFIX,
  MONTHLY_DATA,
  VALUE_CONSUMPTION,
  VALUE_MEASURE6,
  VALUE_MEASURE6_LATEST,
  WEEKLY_DATA,
  YEARLY_DATA,
} from './Apis';

export const userLogin = (data) => {
  return axios.post(LOGIN, data);
};

export const getDeviceValues = (info) => {
  return axios.post(`/reports/deviceValues`, info);
};

// -----------------------------------------------------------------

export const getMaxPower = (id) => {
  return axios.get(MAX_POWER(id));
};
export const getEventDescription = () => {
  return axios.get(EVENT_DESCRIPTION);
};
export const getLatestEvent = (data) => {
  return axios.post(EVENT_LOG_LATEST, data);
};

export const getInverter = (params) => {
  return axios.post(INVERTER, params);
};
export const getValueMeasur6 = (data) => {
  return axios.post(VALUE_MEASURE6, data);
};
export const getValueConsumption = (data) => {
  return axios.post(VALUE_CONSUMPTION, data);
};
export const getValueMeasur6Latest = (data) => {
  return axios.post(VALUE_MEASURE6_LATEST, data);
};

export const getDailyData = (time) => {
  return axios.post(DAILY_DATA, time);
};
export const getWeeklyData = (time) => {
  return axios.post(WEEKLY_DATA, time);
};
export const getMothlyData = (time) => {
  return axios.post(MONTHLY_DATA, time);
};
export const getYearlyData = () => {
  return axios.get(YEARLY_DATA);
};
export const getFirstValueYear = (time) => {
  return axios.post(FIRST_VALUE_YEAR, time);
};

export const inverterSearch = (body) => {
  //SAMPLE BODY : {"serial":"a","requestType":1,"selectedBlock":"BLOCK01","title":"b","block":"w","device":"z"}
  return axios.post(INVERTER_SEARCH, body);
};

export const inverterStatus = (p1) => {
  return axios.get(INVERTER_STATUS(p1));
};
export const getDeviceCode = (param) => {
  return axios.post(`/equipments/categories/parameters`, param);
};

export const inverterGetParams = (p1) => {
  return axios.get(INVERTER_GET_PARAMS(p1));
};
export const inverterGetStatus = (status) => {
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/event-status/${status}`);
};
export const inverterGetStatusByID = (status, id) => {
  return axios.get(
    `${MICROSERVICE_EVENT_PREFIX}/event-status/${status}/equipments/${id}`,
  );
};

export const addAlarm = (data) => {
  return axios.post(ALARMS, data);
};
export const getAlarmsList = (page) => {
  return axios.get(`${ALARMS}?page=${page}`);
};
export const getAlarmsListByCategory = (Category, page) => {
  return axios.get(`${ALARMS}/categories/${Category}?page=${page}`);
};
export const deleteAlarmsList = (id) => {
  return axios.delete(`${ALARMS}/${id}`);
};

export const editAlarmsList = (data, id) => {
  return axios.put(`${ALARMS}/${id}`, data);
};

export const getSpicialAlarmDelete = (id) => {
  return axios.put(`emergencyAlarms/occurred/${id}`);
};

export const UpdateSoundAlarm = (id, param) => {
  return axios.put(`${ALARMS}/sound/${id}`, param);
};

export const getDeviceName = (num1, num2) => {
  return axios.get(`/inverter/status/${num1}/${num2}`);
};
export const editBaseValueEnergy = (data) => {
  return axios.put(`/energies`, data);
};
export const getDeviceParameter = (num) => {
  return axios.get(`/analysis/getEqParams/${num}`);
};

export const getLogs = (data) => {
  return axios.post(`/logs`, data);
};
export const saveTrends = (data) => {
  return axios.post(`/trends`, data);
};
export const getSaveTrends = () => {
  return axios.get(`/trends`);
};
export const deleteSaveTrends = (id) => {
  return axios.delete(`/trends/${id}`);
};

export const addMonitoringError = (data) => {
  return axios.post(`/monitor_errors`, data);
};
export const getMonitoringError = () => {
  return axios.get(`/monitor_errors`);
};
export const deleteMonitoringError = (id) => {
  return axios.delete(`/monitor_errors/${id}`);
};

export const addEquip = (data) => {
  return axios.post(`/equipments`, data);
};
export const deleteEquipment = (id) => {
  return axios.delete(`/equipments/${id}`);
};
export const deviceResetProcess = (deviceCode) => {
  return axios.get(`/process/restart/${deviceCode}`);
};
export const GetEquipmentParams = () => {
  return axios.get(`/equipments`);
};
export const editEquipments = (ID, data) => {
  return axios.put(`/equipments/${ID}`, data);
};
export const GetEquipment = (ID) => {
  return axios.get(`/equipments/${ID}`);
};

export const addEmergencyAlarms = (data) => {
  return axios.post(`/emergencyAlarms`, data);
};
export const getAllParameter = () => {
  return axios.get(`/parameter`);
};
export const getParameterName = (id) => {
  return axios.get(`/parameter/names/${id}`);
};
export const getAlarms = () => {
  return axios.get(`/emergencyAlarms`);
};
export const DeleteAlarms = (ID) => {
  return axios.delete(`/emergencyAlarms/${ID}`);
};

export const handleCloseEmergencyAlarms = (data) => {
  return axios.post(`/emergencyAlarms/occurred/closed`, data);
};

export const handleHistoryEmergencyAlarms = (data) => {
  return axios.post(`/emergencyAlarms/occurred`, data);
};

export const getEventStatusLogs = (data) => {
  return axios.post(`${MICROSERVICE_EVENT_PREFIX}/events/logs/eventStatus`, data);
};
export const getStatusList = () => {
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/event-status`);
};

export const uploadImage = (file) => {
  return axios.post(`/upload`, file);
};

export const addInformation = (data) => {
  return axios.post(`/informations`, data);
};

export const editInformation = (data, id) => {
  return axios.put(`/informations/${id}`, data);
};

export const getInformationData = () => {
  return axios.get(`/informations`);
};
export const deleteInformation = (id) => {
  return axios.delete(`/informations/${id}`);
};

export const getEssentialInformationData = () => {
  return axios.get(`/informations/essential`);
};

export const getDeviceByPhase = (device) => {
  return axios.get(`/equipments/categories/${device}/phase`);
};
export const getPhasesData = () => {
  return axios.get(`/phase`);
};
export const getVendoorsData = () => {
  return axios.get(`/vendors`);
};
export const getVendorByCat = (cat) => {
  return axios.get(`/vendors/categories/${cat}`);
};
export const getModelById = (id) => {
  return axios.get(`/models/${id}`);
};
export const getModelsData = (id) => {
  return axios.get(`/models/vendors/${id}`);
};
export const AddPhase = (data) => {
  return axios.post(`/phase`, data);
};

export const UpdatePhase = (ID, data) => {
  return axios.put(`/phase/${ID}`, data);
};

export const DeletePhase = (ID) => {
  return axios.delete(`/phase/${ID}`);
};

export const getSetting = () => {
  return axios.get(`/setting`);
};

export const editSettingAlarms = (id, data) => {
  return axios.put(`/setting/${id}`, data);
};

export const getVersion = () => {
  return axios.get(`/version`);
};

export const addParameterConfig = (data) => {
  return axios.post(`/parameter-config`, data);
};
export const getParameterConfig = () => {
  return axios.get(`/parameter-config`);
};
export const getParameterConfigByID = (id, name) => {
  return axios.get(`/parameter-config/${id}/${name}`);
};
export const updateParameterConfig = (id, name, data) => {
  return axios.put(`/parameter-config/${id}/${name}`, data);
};
export const deleteParameterConfig = (id, name) => {
  return axios.delete(`/parameter-config/${id}/${name}`);
};
export const addParameter = (data) => {
  return axios.post(`/parameter`, data);
};
export const addParameterWithXL = (data) => {
  return axios.post(`/parameter/bulk`, data);
};
export const updateParameter = (id, data) => {
  return axios.put(`/parameter/${id}`, data);
};
export const deleteParameter = (id) => {
  return axios.delete(`/parameter/${id}`);
};
export const getModbusTCP = () => axios.get('/equipment-parameter');

export const sendCommand = (data) => {
  return axios.post(`/send-command`, data);
};
export const getCommandLogs = () => {
  return axios.get(`/send-command/logs`);
};
export const getCommandLogsByID = (id) => {
  return axios.get(`send-command/logs/by-equipment/${id}`);
};
export const sendModbusCommand = (data) => {
  return axios.post(`/send-command/send-command-modbus`, data);
};
export const performanceReport = (data) => {
  return axios.post(`/performance-ratio`, data);
};
export const smsPanel = (data) => {
  return axios.post(`/sms-panel`, data);
};
export const getSmsPanel = () => {
  return axios.get(`/sms-panel`);
};
export const createCommand = (data) => {
  return axios.post(`/commands`, data);
};
export const getAllCommands = () => {
  return axios.get(`/commands`);
};
export const getCommandsWithEQ = () => {
  return axios.get(`/commands/equipment`);
};
export const getCommandByID = (id) => {
  return axios.get(`/commands/${id}`);
};
export const updateCommand = (id, data) => {
  return axios.put(`/commands/${id}`, data);
};
export const deleteCommand = (id) => {
  return axios.delete(`/commands/${id}`);
};
export const upsertCommands = (data) => {
  return axios.post(`/commands/upsert`, data);
};
export const addAlarmEvents = (data) => {
  return axios.post(`${MICROSERVICE_EVENT_PREFIX}/events`, data);
};
export const updateAlarmEvents = (data, id) => {
  return axios.put(`${MICROSERVICE_EVENT_PREFIX}/events/${id}`, data);
};
export const getAllAlarmEvents = () => {
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/events`);
};
export const getAlarmEventByID = (id) => {
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/events/${id}`);
};
export const getAlarmEventByCategory = (category) => {
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/events/event-category/${category}`);
};
export const deleteAlarmEvent = (id) => {
  return axios.delete(`${MICROSERVICE_EVENT_PREFIX}/events/${id}`);
};
export const getEventsReports = (params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== ''),
  );
  return axios.get(`${MICROSERVICE_EVENT_PREFIX}/events/report`, {
    params: cleanParams,
  });
};
